import React from 'react';
import { CenteredSpinner } from '@components/ui/feedback/CenteredSpinner';
import { Box } from '@mui/material';

import { type ModalType } from './constants';
import { getModalLoadingMessage } from './modalLoadingMessages';

interface ModalLoadingStateProps {
  modalType: ModalType;
}

/**
 * Loading state component for modals.
 * Shows a centered spinner with a contextual loading message.
 * Provides immediate feedback while modal chunks are downloading.
 */
export const ModalLoadingState: React.FC<ModalLoadingStateProps> = ({ modalType }) => {
  const loadingMessage = getModalLoadingMessage(modalType);
  
  return (
    <Box
      sx={{
        minHeight: 300,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 3,
      }}
    >
      <CenteredSpinner 
        message={loadingMessage}
        size={40}
        color="primary"
      />
    </Box>
  );
};

export default ModalLoadingState;